<template>
  <div>
    <el-dialog :visible.sync="visible" title="导入" width="720px" destroy-on-close>
      <div class="content">
        <div>
          <div class="title">选择导入模板</div>
          <template v-if="customers.length > 1">
            <div class="label">服务商</div>
            <div>
              <el-select v-model="customerCode" placeholder="请选择服务商" filterable>
                <el-option
                    v-for="item in tenantList"
                    :key="item.value"
                    :value="item.value"
                    :label="`${item.carrierTenantName}（${item.customerName}）`"
                >
                  {{ item.carrierTenantName }}
                  <span style="color: #ccc">（{{ item.customerName }}）</span>
                </el-option>
              </el-select>
            </div>
          </template>
          <div style="margin-top: 24px">导入方式</div>
          <div style="margin-top: 8px; padding-bottom: 8px">
            <el-radio v-model="type" label="1">导入新站点</el-radio>
            <el-radio v-model="type" label="2">覆盖站点</el-radio>
          </div>
          <div>
            <a-button @click="downloadXls">
              <i class="el-icon-download" style="margin-right: 8px"></i>
              下载模板
            </a-button>
          </div>
          <div class="step">1</div>
        </div>
        <div>
          <div class="title">上传导入模板</div>
          <div>
            <upload
                ref="uploadRef"
                :limit="1"
                action=""
                :on-exceed="handleExceed"
                :auto-upload="false"
                accept=".xls, .xlsx"
            >
              <template #trigger>
                <a-button type="primary">
                  <i class="el-icon-upload2" style="margin-right: 8px"></i>
                  导入文件
                </a-button>
              </template>
              <span />
            </upload>
          </div>
          <div class="desc">
            请确保表格内没有任何公式，否则将造成解析失败<br />
            一次性导入不建议超过1000条，否则电脑性能差的可能导致卡死
          </div>
          <div class="step">2</div>
        </div>
        <div class="dia-footer">
          <a-button @click="visible = false">取 消</a-button>
          <a-button type="primary" :loading="loading" @click="confirmHandler"
          >确 定</a-button
          >
        </div>
      </div>
    </el-dialog>
    <a-modal v-model="modalvisible" title="提交成功">
      <p>请等待几分钟后前往任务跟踪导入结果</p>
      <template slot="footer">
        <a-button
            key="back"
            v-track-click="{ trackName: '导入成功-立即查看' }"
            @click="toTask"
        >
          立即查看
        </a-button>
        <a-button key="submit" type="primary" @click="modalvisible = false">
          知道了
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { getSignType } from '@/api/enterprise/authentication';
import { Upload, Radio } from 'element-ui';
import {mapGetters} from 'vuex'
import { createImport } from '../../api';

export default {
  components: {
    Upload,
    'el-radio': Radio,
  },
  props: {},
  data() {
    return {
      visible: false,
      customerCode: '',
      type: '1',
      loading: false,
      modalvisible: false,
      tenantList: [],
    };
  },
  computed: {
    ...mapGetters('iframe', ['isWmsSystem']),
    customers() {
      return this.$store.state.user.customers || [];
    },
  },
  mounted() {
    // if (this.customers.length) {
    this.getCarrierList();
    // }
  },
  methods: {
    async getCarrierList() {
      const { customers, customerId } = this.$store.state.user;
      const params = customers?.map((item) => item.customerId) || [customerId];
      const data = {
        ids: params,
      };
      const res = await getSignType(data);
      this.tenantList = res.map((item) => {
        return {
          ...item,
          value: item.customerCode,
          label: item.customerName,
          children: [],
        };
      });
      this.customerCode = this.tenantList[0]?.value
    },
    show() {
      this.visible = true;
    },
    handleExceed(files) {
      this.$refs.uploadRef.clearFiles();
      this.$refs.uploadRef.handleStart(files[0]);
    },
    toTask() {
      if (this.isWmsSystem) {
        window.parent.postMessage({}, '*');
        this.modalvisible = false;
        return;
      }
      this.$router.push('/task');
    },
    downloadXls() {
      const a = document.createElement('a');
      if (this.type === '1') {
        a.href = '/xls/station_import.xlsx';
        a.download = 'station_import.xlsx';
      } else {
        a.href = '/xls/override_station.xlsx';
        a.download ='override_station.xlsx';
      }
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    confirmHandler() {
      const file = this.$refs.uploadRef.uploadFiles[0]?.raw;
      if (!file) {
        this.$message.warning('请先导入文件');
      }
      const {
        tenantId,
        tenantName,
        userName,
        userId,
      } = this.$store.state.user;
      const { customerCode } = this;
      const item = this.tenantList.find(e => e.value === customerCode);
      const customerName = item?.label
      const { creditCode}=this.$store.state.user
      const params = {
        file,
        param: null,
        tenantId,
        tenantName,
        userName,
        userId,
        customerCode,
        customerName,
      };
      if (creditCode) {
        Object.assign(params, {
          tenantId: item.carrierTenantId,
          tenantName: item.carrierTenantName
        });
      }
      if (this.type === '1') {
        // 导入新站点
        params.businessType = 'CUSTOMER_STATION_IMPORT'
      } else {
        // 覆盖站点
        params.businessType = 'BASE_STATION_OVERRIDE_IMPORT'
      }
      const form = new FormData();
      Object.keys(params).forEach((k) => {
        form.append(k, params[k]);
      });
      this.loading = true;
      createImport(form)
          .then(() => {
            this.modalvisible = true;
            this.visible = false;
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>
<style>
.el-radio__input.is-checked .el-radio__inner {
  border-color: #059e84;
  background: #059e84;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #059e84;
}
</style>
<style scoped lang="less">
/deep/ .el-dialog {
  border-radius: 10px;
}
.content {
  width: 100%;
  color: #505762;
  & > div {
    margin-left: 11.5px;
    padding-left: 23.5px;
    position: relative;
    &:first-child {
      border-left: 1px solid #b0b7c2;
      // height: 258px;
      margin-bottom: 10px;
      padding-bottom: 24px;
    }
    .step {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1.5px solid #cdd2da;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 14px;
      color: #7e8694;
      position: absolute;
      left: -12px;
      background: #fff;
      top: 0;
    }
    .title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #7e8694;
    }
    .label {
      font-size: 14px;
      line-height: 22px;
      margin-top: 16px;
    }
    .el-select {
      margin-top: 8px;
      width: 240px;
    }

    button {
      margin-top: 16px;
    }
    .desc {
      margin-top: 8px;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.01px;
      color: #7e8694;
    }
  }
  .dia-footer {
    display: flex;
    padding-top: 8px;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
}
</style>
